<template>
  <div class="vc-merchant-logo">
    <img
      v-if="logoUrl"
      id="merchant-logo"
      :src="logoUrl"
      :alt="locale.group ?? 'merchant logo'"
    />
  </div>
</template>

<script setup lang="ts">
  import { useLocaleStore, useMerchantStore } from "@versatile-credit-apply/sdk"
  import { computed } from "vue"
  import { useMerchantLogoAsset } from "@/groups"

  const store = useMerchantStore()
  const locale = useLocaleStore()

  const logo = useMerchantLogoAsset(() => locale.group)
  const logoUrl = computed(() => store.logoConfig?.url ?? logo.value)
  const logoWidth = computed(() => store.logoConfig?.maxWidth ?? "auto")
  const logoHeight = computed(() => store.logoConfig?.maxHeight ?? "auto")
</script>

<style scoped>
  .vc-merchant-logo {
    max-width: v-bind(logoWidth);
    max-height: v-bind(logoHeight);
  }
</style>
